import React, { useEffect, useState } from "react";
import { BaseList } from "../../../../../component/list/base-list";
import { DashboardManagerFilter } from "../../../model/dashboard-manger-filter";
import { getCohortBadgeRatings } from "../../../service/dashboard-manager-service";
import { CohortStudentModuleBadgeRating } from "../../../model/cohort-student-module-badge-rating";
import { columns } from "./cohort-student-module-badge-rating-list-column-definition";
import BaseOperations from "../../../../../component/operations/base-operations";

const storageKey = "DASHBOARD_MANAGER_RATING"

export default function CohortStudentModuleBadgeRatingList({
    filter,
    setFilter
}: {
    filter: DashboardManagerFilter,
    setFilter: React.Dispatch<React.SetStateAction<DashboardManagerFilter>>,
}) {
    const [loading, setLoading] = useState(false);
    const [ratings, setRatings] = useState<CohortStudentModuleBadgeRating[]>([]);

    useEffect(() => {
        if (filter.cohortId !== undefined) {
            setLoading(true);
            getCohortBadgeRatings(
                filter.cohortId,
                Number(filter.moduleId) !== 0 ? filter.moduleId : undefined,
                filter.studentId !== 0 ? filter.studentId : undefined
            ).then(result => {
                setRatings(result);
                setLoading(false);
            });
        } else {
            setRatings([]);
        }
    }, [filter]);

    return (
        <React.Fragment>
            <BaseList
                storageKey={storageKey}
                style={{ marginBottom: "1.5rem" }}
                rows={ratings}
                columns={columns}
                loading={loading}
                localeText={{ noRowsLabel: "No badge ratings" }}
                getRowId={(row) => `${row?.cohortId}-${row?.badgeId}-${row?.studentId}`}
                disableRowSelectionOnClick={false}
                onRowClick={(e) => setFilter({ ...filter, moduleId: e.row?.moduleId, studentId: e.row?.studentId })}
                exportName={`${storageKey}_${filter.cohortId}`}
            />
            {ratings?.length > 0 && <BaseOperations
                helpInfoTexts={[
                    "You can click on a row in the list to select the <b>Module</b> and <b>Student</b>."
                ]}
            />}
        </React.Fragment>
    );
}
